module.exports = __webpack_public_path__ + "img/other-use-case.028711d4.png";